import { Component } from 'react';
import PageTitle from '../../../common/page-title';
import PipEposSubmissionsReport from './pip-epos-submissions-report';
import PipEposSubmissionsReportDatePicker from './pip-epos-submissions-report-date-picker';

class PipEposSubmissionsReportPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: '',
      endDate: ''
    };
  }

  handleStartDateChange = (value) => {
    if (typeof value === 'object') {
      this.setState({ startDate: value.format('DD/MM/YYYY') });
    } else {
      this.setState({ startDate: '' });
    }
  };

  handleEndDateChange = (value) => {
    if (typeof value === 'object') {
      this.setState({ endDate: value.format('DD/MM/YYYY') });
    } else {
      this.setState({ endDate: '' });
    }
  };

  handleClear = () => {
    this.setState({
      startDate: '',
      endDate: ''
    });
  };

  render() {
    const { startDate, endDate } = this.state;

    return (
      <div>
        <PageTitle>
          Epos Reports
        </PageTitle>
        <PipEposSubmissionsReportDatePicker
          startDate={startDate}
          endDate={endDate}
          onHandleStartDateChange={this.handleStartDateChange}
          onHandleEndDateChange={this.handleEndDateChange}
          onHandleClear={this.handleClear}
        />
        <PipEposSubmissionsReport
          startDate={startDate}
          endDate={endDate}
        />
      </div>
    );
  }
}

export default PipEposSubmissionsReportPage;
